import React from 'react'
import { createRoot } from 'react-dom/client'
import { select } from 'redux-saga/effects'
import RecentPatientsWidget from 'GeneralUI/RecentPatientsWidget/RecentPatientsWidget.jsx'

export function* renderPatientSearchHistory(action) {
  const { fromMoreIcon, quickAccessRef = {} } = action
  if (quickAccessRef.current != null) {
    // create an empty div to attach to the parent
    const widgetContainer = document.createElement('div')
    const root = createRoot(widgetContainer)
    // apprent the empty div to the parent so we have a place to render the widget
    quickAccessRef.current.appendChild(widgetContainer)
    // select data required for the widget component from redux
    const appConfig = yield select(state => state.appConfig)
    const router = yield select(state => state.router)
    
    // render the component into the newly created div
    root.render(
      <RecentPatientsWidget
        appConfig={appConfig}
        fromMoreIcon={fromMoreIcon}
        router={router}
        parentRef={widgetContainer}
        closeSelf={e => {
          quickAccessRef.current.removeChild(widgetContainer)
        }}
      />
    )
  }
}
